import * as React from 'react';
import type { SVGProps } from 'react';
const SvgImages = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M18 15V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3M4 5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v4.36l-1.08-1.09a2.56 2.56 0 0 0-1.81-.75 2.58 2.58 0 0 0-1.81.75l-.91.91-.81-.81a2.93 2.93 0 0 0-4.11 0L4 9.85Zm.12 10.45A.94.94 0 0 1 4 15v-2.33l2.88-2.88a.91.91 0 0 1 1.29 0l.83.81Zm8.6-5.76a.52.52 0 0 1 .39-.17.52.52 0 0 1 .39.17l2.5 2.49V15a1 1 0 0 1-1 1H6.4ZM21 6a1 1 0 0 0-1 1v10a3 3 0 0 1-3 3H7a1 1 0 0 0 0 2h10a5 5 0 0 0 5-5V7a1 1 0 0 0-1-1" />
  </svg>
);
export default SvgImages;
